export default class NavPrimary {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
  }

  setVars() {
    this.container = this.el.querySelector('[data-nav-container]')
    this.body = document.querySelector('body')
    this.logo = this.el.querySelector('[data-nav-logo]')
    this.allLi = this.el.querySelectorAll('li')
    this.p = this.el.querySelector('[data-nav-persistent]') // assume this is the open trigger
  }

  init() {
    if (this.allLi.length > 0) {
      this.el.classList.add('s-watching')
      this.handleAdapt()
      window.addEventListener('resize', this.handleAdapt)
    }
  }

  handleAdapt = () => {
    if (typeof (this.p === 'undefined')) {
      return
    }
    const hiddenItems = []
    const logoWidth = this.logo.offsetWidth
    const maxWidth = this.container.offsetWidth
    let stopWidth = this.p.offsetWidth + logoWidth + 100

    this.allLi.forEach((item) => {
      item.classList.remove('s-hidden')
    })
    this.allLi.forEach((item, i) => {
      if (maxWidth >= stopWidth + item.offsetWidth) {
        stopWidth += item.offsetWidth
      } else {
        item.classList.add('s-hidden')
        hiddenItems.push(i)
      }
    })
  }
}
